import Vue from "vue"
import App from "./community.vue"
import router from "./router"
import cloudbase from "@cloudbase/js-sdk/app" // 内核
import "@cloudbase/js-sdk/auth" // 登录模块
import "@cloudbase/js-sdk/functions" // 云函数模块
import "@cloudbase/js-sdk/storage" // 云存储模块

const cloud = cloudbase.init({
  // env: 'dev-9gj3tj84f6fb4b8a'
  env: "prod-3g183eilea4cd96b",
})

import {
  Message,
  Input,
  Upload,
  Autocomplete,
  Icon,
  Tabs,
  Button,
  TabPane,
  Avatar,
  Dialog,
  MessageBox,
  Image,
  Checkbox,
  Loading,
  Popover,
  MessageBox,
  Table,
  TableColumn,
} from "element-ui"
import "element-ui/lib/theme-chalk/index.css"

Vue.config.productionTip = false
//引入elementUi组件
// Vue.use(Message)
Vue.use(Checkbox)
Vue.use(Input)
Vue.use(Upload)
Vue.use(Autocomplete)
Vue.use(Icon)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Avatar)
Vue.use(Dialog)
Vue.use(Image)
Vue.use(Popover)
Vue.use(Loading)
Vue.use(Table)
Vue.use(TableColumn)
Vue.prototype.$message = Message
Vue.prototype.$MessageBox = MessageBox
Vue.prototype.$cloudAuth = cloud.auth()
Vue.prototype.$cloud = cloud

const communityApp = new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
})



//////////////////
// WEBPACK FOOTER
// ./entries/community/main.js
// module id = null
// module chunks = 